import { injectToolCSS } from "../utils/cssGenerator";
import IToolConfig from "../types/IToolConfig";
import disableAnimatedImages from "./disableAnimatedImages";

export const stopAnimationsConfig: IToolConfig = {
    id: "stop-animations",
    selector: `html`,
    childrenSelector: ['*'],
    styles: {
        'transition': 'none',
        'animation-fill-mode': 'forwards',
        'animation-iteration-count': '1',
        'animation-duration': '.01s'
    }
}

export default function stopAnimations(enable=false) {
    // Neutralise CSS transitions/animations...
    injectToolCSS({
        ...stopAnimationsConfig,
        enable
    });
    // ...and stop motion CSS can't touch: animated GIFs and autoplaying videos.
    disableAnimatedImages(enable);
}